import contrato from './contrato';
import MainReportes from '@/views/administracion/reportes/Main.vue';
import DefaultConsulta from '@/views/administracion/reportes/contratos-consoluta/Default.vue';
import MainReporteSemanal from '@/views/administracion/reportes/reporte-semanal/Main.vue';
import MainEstadisticasConsultas from '@/views/administracion/reportes/estadisticas-consulta/Main.vue';

const auth = ['Consultas:ver'];
const scopes = ['Consultas:crear', 'Consultas:editar', 'Consultas:eliminar'];

const reportes = [
  {
    path: 'consultas',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: MainReportes,
    children: [
      {
        name: 'consultasEstatusContratos',
        path: '/',
        meta: {
          title: 'Consulta',
          auth,
          scopes,
        },
        component: DefaultConsulta,

        children: [],
      },
      {
        name: 'consultasInformeEjecutivo',
        path: 'informe-ejecutivo',
        meta: {
          title: 'Semanal',
          auth,
          scopes,
        },
        component: MainReporteSemanal,

        children: [],
      },
      {
        name: 'consultasEstadisticas',
        path: 'estadisticas',
        meta: {
          title: 'Estadisticas',
          auth,
          scopes,
        },
        component: MainEstadisticasConsultas,

        children: [],
      },
    ],
  },
  ...contrato,
];

export default reportes;
